<div class="parent">
  <div class="mobileScreen col-6 col-md-6">
    <div class="positioner">
      @if (loader) {
        <div [ngStyle]="{'cursor':cursor,'aspect-ratio':canvasAspect}" class="mainDivLoader">
                <span style="font-size: 136px;" [ngClass]="{
                                 'bi bi-android android': device?.platform == 'Android',
                                 'bi bi-apple iOS': device?.platform == 'iOS'}">
          </span>
          <label class="loadbar" [ngStyle]="{'top': getTopPosition(device)}">
            <span class="sr-only"></span>
            <progress class="progressBar"></progress>
          </label>
        </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas class="screen"></canvas>
      <!-- <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
      focus-element="$root.screenFocus" /> -->
    </div>
    <div id="device-name">
      {{this.device.enhancedName}}
    </div>
  </div>

  <div class="col-6 col-md-6 logSection">
    <div id="heading">
      <h3>Select upto 4 Slave Devices</h3>
    </div>
    <div id="inputPackageName">
      <input type="text" class="form-control" placeholder="Enter Package Name" [(ngModel)]="packageName"
        (keyup.enter)="onPackageNameSubmit()" />
      <button class="btn btn-primary"
        [disabled]="!packageName || packageName.trim() === '' || this.selectedDevices.length === 0"
      (click)="onPackageNameSubmit()">Submit</button>
      <button id="reset-btn" class="btn btn-secondary" [ngStyle]="" (click)="resetPackageName()">X</button>
    </div>

    <div class="tab-content" id="logsTabContent">
      <div class="tab-pane fade show active" id="deviceSelection" role="tabpanel"
        aria-labelledby="deviceSelection-tab">
        <!-- The UL tag is placed here but will be accessible regardless of active tab -->
        <ul id="deviceList" class="devices-icon-view device-list"></ul>
      </div>
    </div>
  </div>
</div>

<ng-template #alertMod let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>&nbsp;
    </div>
  </div>
</ng-template>